import { CommonModule, NgClass } from '@angular/common';
import { HttpResponse } from '@angular/common/http';
import { Component } from '@angular/core';
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { Router, RouterLink, RouterModule } from '@angular/router';
import { FileUploadModule } from '@iplab/ngx-file-upload';
import { first } from 'rxjs';
import { CustomizerSettingsService } from '../../customizer-settings/customizer-settings.service';
import { AuthenticationService } from '../../services/authentication.service';
import { LoadingService } from '../../services/loading.service';
import { LocalStorageService } from '../../services/local-storage.service';
import { whitespaceExistsValidator } from '../../validators/ValidationService';

@Component({
    selector: 'app-forgot-password',
    imports: [RouterLink, NgClass, FileUploadModule, RouterModule, ReactiveFormsModule, CommonModule],
    templateUrl: './forgot-password.component.html',
    styleUrl: './forgot-password.component.scss'
})
export class ForgotPasswordComponent {

    // isToggled
    isToggled = false;
    frmForgotPasswordForm!: FormGroup;
    isPasswordVisible = false;
    submitted = false;
    isLoginSuccess: boolean = false;
    error = '';
    returnUrl!: string;

    constructor(
        public themeService: CustomizerSettingsService,
        private formBuilder: FormBuilder,
        private loadingService: LoadingService,
        private localStorage: LocalStorageService,
        private authService: AuthenticationService,
        private router: Router
    ) {
        this.themeService.isToggled$.subscribe((isToggled: boolean) => {
            this.isToggled = isToggled;
        });

        if (this.authService.isUserAuthenticated()) {
            this.router.navigate(['dashboard']);
        }
    }

    ngOnInit(): void {
        this.initializer();
    }

    private initializer(): void {
        this.frmForgotPasswordForm = this.formBuilder.group({
            emailControl: ['', [Validators.required, Validators.email, whitespaceExistsValidator()]]
        });
    }

    // convenience getter for easy access to form fields
    get f() { return this.frmForgotPasswordForm.controls; }


    onSubmit() {
        debugger
        this.submitted = true;
        this.error = "";

        if (this.frmForgotPasswordForm.invalid) {
            return;
        }

        this.loadingService.showLoading();

        this.authService.forgotPassword(this.f['emailControl'].value)
            .pipe(first())
            .subscribe({
                next: (result: HttpResponse<any>) => {
                    if (result.body && result.body.message === "Reset email sent") {
                        this.isLoginSuccess = true;
                        this.error = "Email sent successfully";

                        this.router.navigate(['login']);
                    } else {
                        this.isLoginSuccess = false;
                        this.error = result.body?.message || "Something went wrong";
                    }

                    this.loadingService.hideLoading();
                },
                error: error => {
                    this.isLoginSuccess = false;
                    if (error?.error?.message) {
                        this.error = error.error.message;
                    } else {
                        this.error = "Something went wrong";
                    }

                    this.loadingService.hideLoading();
                }
            });
    }


}